import { Phone, Calendar, ClipboardCheck } from 'lucide-react';

const buttonStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '6px',
  padding: '10px 18px',
  fontSize: '13px',
  whiteSpace: 'nowrap',
  height: '40px',
  margin: '0',
  fontWeight: '600',
  borderRadius: '25px',
  transition: 'all 0.3s ease',
  textDecoration: 'none',
  border: 'none',
  cursor: 'pointer'
};

const HeaderCTA = () => {
  const phone = window.APP_CONFIG?.PHONE || '514-570-9802';
  const reservationUrl = 'https://booking-hub-406.emergent.host/api/booking?type=rdv';
  const estimationUrl = 'https://booking-hub-406.emergent.host/api/booking?type=est';
  
  return (
    <div className="header-cta-desktop" style={{ display: 'flex', gap: '12px', alignItems: 'center', height: '100%' }}>
      <a
        href={`tel:${phone}`}
        className="call-button-header"
        style={{ ...buttonStyle, backgroundColor: '#2563eb', color: 'white' }}
      >
        <Phone size={16} />
        <span>APPELER</span>
      </a>
      <a
        href={reservationUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="urgency-badge"
        style={{ ...buttonStyle, backgroundColor: '#dc2626', color: 'white', animation: 'none', transform: 'none' }}
      >
        <Calendar size={16} />
        <span>RÉSERVER</span>
      </a>
      <a
        href={estimationUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ ...buttonStyle, backgroundColor: '#ea580c', color: 'white' }}
      >
        <ClipboardCheck size={16} />
        <span>ESTIMATION</span>
      </a>
    </div>
  );
};

export default HeaderCTA;
